// extracted by mini-css-extract-plugin
export default {"bottomMenu":"Bottombar_bottomMenu__ldTmi","menu":"Bottombar_menu__0xeyL","icon":"Bottombar_icon__a7WW2"};